export const CardDeviceType: { ios: string, android: string } = Object.freeze({
    ios: "1",
    android: "2"
});

export const SelfDeviceType: { android: string, ios: string } = Object.freeze({
    android: "1",
    ios: "2"
});